import React from 'react';

export const ReptoolToast = ({ closeToast, toastProps, data }) => {
    return (
        <div className='d-flex flex-row'>
            <div >
                <img src='/images/logo_transparent.png' width='50' alt='RepTool logo' />
            </div>
            <div className='flex-fill mr-2 ml-3'>
                <h4>{data.title}</h4>
                <p>{data.body}</p>
            </div>
        </div>
    )
}